import VDialogTeacherAddApply from './index.vue';

export default {
  install: (Vue) => Vue.component('VDialogTeacherAddApply', VDialogTeacherAddApply),
};
